export const constants = {
  ENDPOINT: "http://localhost:9001",
  MS_SERVICE_URL: "http://ms-service.local1.nopaperforms.in"
};
export const gtm_Key = 'GTM-N2MJSG4'
// export const gtm_Key = 'GTM-PLFW6Q44'
// export const AMPLITUDE_API_KEY = '95bf0ea3fae427bac09faf59bb303932';
export const AMPLITUDE_API_KEY = '';
export const echoStatusLabel = {
  '0':'',
  '1':'Niaa',
  '2':'Queued',
  '3':'Picked',
  '4':'Resolved',
  '5':'Resolved',
}
export const echoStatusButton={
  '1':'Intervene',
  '2':'Intervene',
  '3':'Resolve',
  '4':'Intervene',
  '5':'Intervene'
}

export const echoTabName ={
  'All' : '0',
  'Niaa': '1',
  'Queued':'2',
  'Picked':'3',
  'Resolve':'4',
  'AutoResolve':'5'
}

export const monthsName={
    1: 'Jan',
    2: 'Feb',
    3: 'Mar',
    4: 'Apr',
    5: 'May',
    6: 'Jun',
    7: 'Jul',
    8: 'Aug',
    9: 'Sep',
    10: 'Oct',
    11: 'Nov',
    12: 'Dec'
  
}
export const callByItems = {
  mobile:'mobile',
  widget:'echo_widget_listing',
  livechat:'livechat',
  widgetLead:'echo_widget_chat',
  widgetLeadProfile:'applicant_profile'
}